import axios from "axios";
import { uploadImage } from "./imageLoader";
import mainAxios from "../redux/api/mainAxios";

// Function to upload a PDF document and create a document entry
export const uploadAndCreateDocumentEntry = async (
  file,
  reference,
  type = "document"
) => {
  if (!file) return null;

  try {
    // 1. Upload the file to media library
    const uploadedFile = await uploadImage(file);

    // 2. Create a document entry in the documents_pdfs collection
    const documentData = {
      data: {
        name: file.name || `Document for ${reference}`,
        origine: "novanea",
        original_id: reference,
        original_url: uploadedFile.url,
        type: type,
        document: uploadedFile.id,
      },
    };

    const documentEntryResponse = await mainAxios.post(
      `${process.env.REACT_APP_ENDPOINT_URL}api/documents-pdfs`,
      documentData
    );

    if (!documentEntryResponse.data) {
      throw new Error("Failed to create document entry");
    }

    // Return the document entry data with its ID
    return documentEntryResponse.data.data;
  } catch (error) {
    console.error("Error in uploadAndCreateDocumentEntry:", error);
    throw error;
  }
};
